import { QueryClientProvider } from '@tanstack/react-query'
import { useEffect, type ReactNode } from 'react'

import { Toaster } from '@/components/feedback/Toaster'
import { queryClient } from '@/lib/queryClient'
import { subscribeSystemTheme } from '@/stores/themeStore'

export function AppProviders({ children }: { children: ReactNode }) {
  useEffect(() => subscribeSystemTheme(), [])

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <Toaster />
    </QueryClientProvider>
  )
}
